// import lazyload from './lazyload';
import ScriptLoader from '../fsUtils/ScriptLoader';
import lockfnqueuing from './lockfnqueuing';
import lockfncaching from './lockfncaching';

var factory = function() {

  var o = {};

  o.timeout = 1000;

  // redefine if you'd prefer using different lazyload or locking functions
  o.ScriptLoader  = new ScriptLoader;
  o.lockfnqueuing = lockfnqueuing;
  o.lockfncaching = lockfncaching;

  o.neoscripturl = (function(loc){

    var metaEl = document.querySelector('[fs-prop="video"]');
    var scripturl = metaEl && metaEl.getAttribute("script");

    if (scripturl === null) {
        scripturl = '//player.foxneodigital.com/sports';
    }

    if (window.location.search.indexOf('debugVideoPlayer') > -1) {
        if (scripturl.indexOf('?') > -1) scripturl = scripturl + '&debug=all';
        else scripturl = scripturl + '?debug=all';
    }

    return scripturl;

  }(window.location));

  o.gEBI = function (opts, id) {
    return document.getElementById(id + opts.id);
  };

  o.getContainerElem = function (opts) {
    return o.gEBI(opts, 'Video');
  };

  o.isContainerElem = function (opts) {
    return o.getContainerElem(opts) ? true : false;
  };

  o.loadfdmplayer = o.lockfncaching(function (fn) {
    if (typeof FDM_Player === 'function') {
      fn(null, FDM_Player);
    } else {

      console.log('fs video script url ', o.getVideoScriptUrl());

      o.ScriptLoader.getScript(o.getVideoScriptUrl(),function () {
        if (typeof FDM_Player === 'function') {
          fn(null, FDM_Player);
        } else {
          fn('failed to load');
        }
      },false);

    }
  });

  o.getvideoelements = function () {
    return [].slice.call(document.querySelectorAll(
        '.platformPlayer:not(.tpPlayer)'
    ));
  };

  o.isvideodata_autoplay = function (data) {
    return data && data.autoplay;
  };

  o.incrnum = 0;
  o.getvideoelementdata = function (elem) {
    var elemdata,
        idnum = ++o.incrnum;
    var randNum = Math.floor(Math.random().toFixed(2)*100);

    if (elem instanceof Element) {
      elemdata = JSON.parse(elem.getAttribute('data-player-config'));
      if (!elemdata.id || !elem.id) {
        elemdata.id = idnum + randNum.toString();
        elem.id = 'Video' + idnum + randNum.toString();
      }
    }

    return elemdata;
//    return elem instanceof Element &&
//      JSON.parse(elem.getAttribute('data-player-config'));
  };

  o.getvideoelementsdata = function () {
    return o.getvideoelements().map(o.getvideoelementdata);
  };

  // iu (interactive unit) is similar to a page path
  // ex., '/fscom/homepage/video', '/fscom/nfl/video'
  o.fdmplayer_getdefaultopts = function () {
    return {
      autoplay           : true,
      share              : false,
      share_embed        : true,
      endcard            : true,
      endcard_feed       : '',
      endcard_countdown  : true,
      iu                 : '',
      fdmsharetargetsArr : [{
        name: "Facebook",
        image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAACl0lEQVR42u3a3UsUURzGcf+vELuI8iK6iLrIzOidoheCUC+yF4KitEAJcq11UyplVzaKyo1dEBZXslwlpUAqS6LxQszNyG3dml9zYgiJ2pyZnT20fh94Ls7VwO8zMMM5p2LNtnbDqljNWc1bNe01LX5Ne8Y5e21UMBS9BQAAABgEAABQAACgAABAAQCAAgDAqurWY3fkxMVH0hJMSkf4qYSiaQn2jfxqoHdYWrtTcr59QJpa43L8wgPZ2RiRTQe7paq2AwCnXVt3XU63JSQx9FoyC1nxms1HbgGwkq7bFbTe6Gcy/8n70Jdny9HbAPyrDS0xmZv/In4EgAKt3B6QnofPxc8AUGD48dQr8TsA/KV9jyekFAHgD1W/i6UKAL+1em9IMp+zAOhqr88fXQAKdMOeTsl+zQOgq1dCg1LqALCsoy8+AKBzq+G7aQKgq4fP3S/KQFOj09IcTMq+k9Gfw1XflUKtrAkAoKq2jL1E7YweOnuP8wC3DfePewJQ+/wcyHjowPAb18OfnJrlRMxrh8amXQPcjKYB8Nqxl4ZrgDNXEwDoBKhv7gdAJ4D6hQUAAAAAAAAAAAAAAAAAAFjVADvqw5IceeuoXm5CjE/OOH6e6qUbyfIEKNbhit+51vMEAJ051RYHQGfUsSUAGrPxQBcAuqIugJXtX9D/ADD1/iMAOjOYfgeAzkRiEwDojLqHBIDGNF6OAaAzdQ0RAHRm/e5OAHRFbfyV9W7o/qa7MjO74KhLS99cD3Qus+joWeoGNecBnAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj2Imc1b9UEwLea9oxz9tr4AS/jbaNehFRZAAAAAElFTkSuQmCC",
        urlTemplate: "http://www.facebook.com/sharer.php?u=<%= url %>"
      }, {
        name: "Twitter",
        image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAIAAABt+uBvAAAFGUlEQVR42u2b+W8TVxDH80/WCQHSCEUtLagHoodKS6tWRRShNkUQ9aAIqVVb0fhITGISIElNnPtwE0hCMM1JYhKzh/e+O5IhVRPq2uv33m7ojN4PtiXvvv3svO/MvJ2te6mdw1Fm1CECBISAEBACQkAICAEhIBwICAEhIASEgBAQAkJAOBAQAkJACAgBVTUOJ/gLY3J6xVgv2pbjlYzTnJnH1i931TduCBUeJ/LiAWrq4OMLmmq5XlnL5s33b4tljvNWj5hZM5o7eHaAPuwvRijT+TQtgZt4lZnreslFrSG2+yAfDRSH1w3H9QaWDXZL7GCc5zWnfV6jR+eHacV1vWrt7pb1cgdfH+XAoWB6j4p26Xfb8d7sEdkBujQul078/ZRCg843k4rn1wqqs3dJ+ruX/gFNbZo75744LpOlc6q/6LgeQZvbthqiDKNYJMrtukWXp4n5UWOM25QcgnRynNXc+VSbjyT51lGZOqDjKWHvPBL3NSKafTWrEKQzuWlCHHytW2ibkCc2TMN2P/m9SB3QB33F585mfMOsNo7u9c0thZj7CLoLUECSdn759Z7KYonBTfi3OeVlB/D5BnR6oOhRs/5lg1Gi+N5tscw8QF8hZDTG/bhSdF6jRAdc6UCMlUi3JIX/nNCG5JwZlKo9MlwGDTp3Vo36KNtarMIEd3bLqmrFLQs2cTrX5vxHD/+A+pb0qrLbc0NSpIJ7SFChS3altvyjroYqqWo13Vac2IJ2ordcvr8qEvYguDGBbXcs8T4vBiJd9wP9/LDUktwt5OBrLw6gMsG+cgMty+bNGzn9xxkVShb4TBZQVWkh+f2g3oe6F24rv0lErRZ79gEyi1nSi4Ksvd0bBKALY/LgqlGK34fi/MxjM7SADsX5AACdzUil00NUTq8YP8+qoLshpAMCF8ym/cmborcfbH7bCgZQQ5TTLTf8gHoe6oE99hlZN8MP6OtROTBAXzyToTDb691CYICgsCJeFpC1gurUvr1ZU6LooxxjaamcHjAgGF0PwptJ11hkkAFUH6W1xVWjibrrb4eM/LN5qDYya0bYAHUuknnkS6Z5AUqzy9OKFprMCOZxLCWECFBpvHJd6M7pYcAEqz5c/UHHU8LRLqEpwTd38id6xb4l3XL2vTyTBNQ6KodHfabzJsFlQQYQ6LSgh0WA3r0lhg5QqZcnDHTSKwZBOiQBQdJxvxDw1qJiui1JIaSAYIBOP1GDFOdLpNuUyDdxQggLitHIukmcDpUuV/Aj9mttS3F2WqT2QZ806NGVrCLojFxJt9yTN0UaF0K3Txpi/8VxeeyRqZoUMwDX9c5mJHpXwaKRHBwK1h0EYBqA2iZkqpNnAQjoUNoSodSBzA7QwTj/04xKo3y1Ha91VGZwd2kBaurgr/6h8hoVnZYM92Ny5ShTQI0x7sygBNW8btMS5hxn1/6sgiKgV7uExtjfjw+PJPl3bonnh6Xf5rRs3qS6GeS4XmLhOe+qhAvQqf5iqW+KcfH+J2/X2MjCbolB2P52UimwKingRG0TSiTKsadTkwZBHvjdlLLzshEN25BsOMWBWDBoyIh0pJ37LC1l1gyDnCqbjje0Znx+RwrKa6hEscMJ/qsReWDZ8L30oOCEv385Ijcl+MC50M2DjqUEiGvtcxo4wuITC5Ap/yzH4Oum5CwULKg/rt1Tzw1JkG3jW8/4WjgCQkA4EBACQkAICAEhIASEgHAgIASEgBAQAkJACAgB/b/HXwPPdZ/z7BalAAAAAElFTkSuQmCC",
        urlTemplate: "http://twitter.com/share?url=<%= url %>&text=<%= title %>"
      }, {
        name: "googleplus",
        image: "data:image/png;base64,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",
        urlTemplate: "https://plus.google.com/share?url=<%= url %>"
      }]
    };
  };

  o.fdmplayer_getdefaultoptswith = function (opts) {
    var playeropts = o.fdmplayer_getdefaultopts();

    Object.keys(opts).map(function (key) {
      playeropts[key] = opts[key];
    });

    // iu (interactive unit) is similar to a page path
    // ex., '/fscom/homepage/video', '/fscom/nfl/video'
    if (typeof playeropts.iu === 'string') {
      playeropts.releaseURL += '&iu=' + playeropts.iu;
      playeropts.endcard_feed += '&params=iu=' + playeropts.iu;
    }

    return o.fdmplayer_getdefaultoptsvalidated(playeropts);
  };

  // if video player element is not 'tall', FDM_Player throws this error:
  //
  //   Error: Ad adLoadError error: Parameter linearAdSlotHeight must be greater than 0. errorCode: 1103:ArgumentError: Parameter
  //
  o.fdmplayer_isvalidcontainer = function (opts) {
    var containerelem = o.getContainerElem(opts),
        minh = 50;

    return true;
  };

  o.fdmplayer_getdefaultoptsvalidated = function (opts) {
    function isboolean (opts, propname) {
      if (typeof opts[propname] !== 'boolean') {
        throw new Error('fsdvideo: property must be defined as boolean, ' + propname + ' ');
      }
    }

    function isstring (opts, propname) {
      if (typeof opts[propname] !== 'string') {
        throw new Error('fsdvideo: property must be defined as string, ' + propname + ' ');
      }
    }

    if (o.fdmplayer_isvalidcontainer(opts)) {
      isboolean(opts, 'autoplay');
      isboolean(opts, 'share');
      isboolean(opts, 'share_embed');
      isboolean(opts, 'endcard_countdown');

      //isstring(opts, 'id');
      isstring(opts, 'releaseURL');
      isstring(opts, 'endcard_feed');
    }

    return opts;
  };

  o.doexpire = function (fn, expirems) {
    var fnopen = true,
        expirefn = function () { fnopen && !(fnopen = false) && fn(); };

    setTimeout(expirefn, expirems);

    return expirefn;
  };

  o.getbaseurl = function () {
    var l = window.location;

    return l.origin ||
        l.protocol + '//' + l.hostname + (l.port ? ':' + l.port : '');
  };


  o.getVideoScriptUrl = function() {
    var videoScriptUrl = o.neoscripturl;

    return videoScriptUrl;
  };

  /*
   desktop = 992 pixels and up
   tablet = 768 - 991
   handheld = 767 and below
   Touch detection for 991 and below would override the breakpoints
   */
  o.getAdViewport = function(windowWidth){

    var isTouch = o.isTouchDevice();

    var viewportName = 'www';

    switch (true) {
      case (!isTouch || windowWidth > 991):
        viewportName = "www";
        break;
      case (windowWidth > 767 && isTouch):
        viewportName = "mtab";
        break;
      default:
        viewportName = "mweb";
    }

    return viewportName;
  }

  o.isTouchDevice = function(){
    return 'ontouchstart' in window;
  }

  o.getAdZoneParam = function(){

    function getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
          results = regex.exec(location.search);
      return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    var adzoneParam = getParameterByName('adzone');

    if(adzoneParam !== ""){
      return adzoneParam;
    }else{
      return '';
    }

  },

      o.setSiteSection = function(player,siteSectionPath,_this){

        //freewheel
        if(typeof siteSectionPath !== 'undefined'){
          console.log('has siteSection');
        }else{
          siteSectionPath = '/nfl/test/default';
        }

        var fwSiteSection = siteSectionPath;
        // condition if siteSection already sets 'www.'
        if (fwSiteSection.indexOf('www.') > -1) {
          fwSiteSection = fwSiteSection.replace('www.','');
        } 

        fwSiteSection = _this.getAdViewport(window.innerWidth) + '.' + fwSiteSection;        

        //get adzone
        var adZoneVal = o.getAdZoneParam();
        //assign siteSection
        player.siteSection = (adZoneVal !== "") ? adZoneVal : fwSiteSection;

        console.log('siteSection: ', player.siteSection);

        return player;
      }

  //o.isFWEnabled = function(url){
  //  return (url.indexOf("fw=enabled") > -1) ? true : false;
  //}

  // constructs an FDM_Player instance
  // if a function is given as 'fn',
  //   autostart player and call 'fn' when video (not ad) begins
  //
  // create a 'start' method which calls 'bind'
  //   'start' might communicate purpose better than 'bind'
  //

  o.fdmplayer_get = function (FDM_Player, opts, fn) {
    var playeropts = o.fdmplayer_getdefaultoptswith(opts),
        player = new FDM_Player(o.getContainerElem(opts).id);

    player.autoplay = playeropts.autoplay;

    if(window.innerWidth > 1024) {
      // older implementations incorrectly return share as a boolean
      if (typeof playeropts.share === 'object' && playeropts.share) {
        player.share            = playeropts.share;
      } else {
        player.share            = {

          showembedfunc: function(mid,vi) {
            if((vi.primary == 'nfl' && vi.contentType == 'highlights') ||
                (typeof this.state.clip === 'object' && typeof this.state.clip !== null && this.state.clip.baseClip.contentCustomData["non-EmbeddableHighlights"] == "true")) {
              return false;
            } else {
              return true;
            }
          },
          emailscript: "",
          sharetargets: playeropts.fdmsharetargetsArr};
      }
      if (typeof playeropts.share_deeplinkfunc === 'function') {
        player.share.deeplinkfunc = playeropts.share_deeplinkfunc;
      }
      else {
        player.share.deeplinkfunc = function (mediaid, title, guid) {
          return o.getbaseurl() + '/video?vid=' + mediaid;
        };
      }
    }

    player.share_embed        = playeropts.share_embed;
    player.endcard            = playeropts.endcard;
    player.endcard_feed       = playeropts.endcard_feed;
    player.endcard_countdown  = playeropts.endcard_countdown;
    player.releaseURL         = playeropts.releaseURL;
    player.start = function () {
      performance.mark("fs-videoplayer-startplayer");
      return player.bind(), player;
    };

    if (typeof playeropts.onMediaPause === 'function') {
      player.addEventListener('OnMediaPause', function (e) {
        performance.mark("fs-videoplayer-onmediapause");
        playeropts.onMediaPause(null, e, player);
      });
    }

    //check is free wheel enabled
    if(playeropts.isFwEnabled == true){
      player = o.setSiteSection(player, playeropts.siteSection, o);
    }

    player.start = function() {
      performance.mark("fs-videoplayer-startplayer");
      return player.bind(), player;
    };

    if (typeof playeropts.onMediaPause === 'function') {
      player.addEventListener('OnMediaPause', function(e) {
        performance.mark("fs-videoplayer-onmediapause");
        playeropts.onMediaPause(null, e, player);
      });
    }

    if (typeof playeropts.onMediaStart === 'function') {
      player.addEventListener('OnMediaStart', function(e) {
        performance.mark("fs-videoplayer-onmediastart");
        playeropts.onMediaStart(null, e, player);
      });
    }

    if (typeof fn === 'function') {
      player.addEventListener('OnMediaLoadStart', function(e) {
        performance.mark("fs-videoplayer-onmedialoadstart");
        if (o.isContainerElem(playeropts) && !e.data.baseClip.isAd) {
          fn(null, e, player);
        }
      });

      player.start();
    }

    return player;
  };

  o.start = o.lockfnqueuing(function (opts, fn) {
    o.loadfdmplayer(function (err, FDM_Player) {
      var player = o.fdmplayer_get(FDM_Player, opts, o.doexpire(fn, o.timeout));

      // set player object to be accessible on global object
      if (!window.fdmPlayer) window.fdmPlayer = [];
      window.fdmPlayer.push(player);
    });
  });

  o.startall = function (callback) {
    performance.mark("fs-videoplayer-startall");
    o.getvideoelementsdata().map(function (videodata) {
      o.start(videodata, function (err, e, player) {
        console.log('player is started!', e, player);
        if (typeof callback !== 'undefined') {
          callback();
        }
      });
    });
  };

  return o;

};


var fsVideoLoader = factory();
export default fsVideoLoader;



// WEBPACK FOOTER //
// ./assets/components/platformPlayer/fsVideoLoader.js